import { CompanyEmployees } from '@/modules/simulator/hooks'
import { PEOPLE_1_TO_5 } from '@/modules/simulator/constants/company-size'

const isCompanyME = (employeesNumber: CompanyEmployees): boolean => {
  return employeesNumber === PEOPLE_1_TO_5
}

export { isCompanyME }
